
import React, { useEffect, useState } from 'react';
import { Layout } from '@/components/Layout';
import { useResources } from '@/hooks/useResourceContext';
import CategoryBlock from '@/components/CategoryBlock';
import { toast } from 'sonner';
import AdminLoginDialog from '@/components/AdminLoginDialog';
import ChangeCredentialsDialog from '@/components/ChangeCredentialsDialog';
import WelcomeHeader from '@/components/WelcomeHeader';
import UpdateAcknowledgment from '@/components/UpdateAcknowledgment';

// Access the production environment flag from the window object
// This will always be correctly set on each page load
const isProduction = typeof window !== 'undefined' && window.__IS_PRODUCTION__ === true;

const Index = () => {
  const { 
    categories, 
    resources, 
    isAdmin, 
    settings, 
    login, 
    logout, 
    changeCredentials, 
    toggleDeveloperMode, 
    _timestamp,
    _lastUpdateTimestamp,
    _updateAcknowledged
  } = useResources();
  
  const [isLoginDialogOpen, setIsLoginDialogOpen] = useState(false);
  const [isCredentialsDialogOpen, setIsCredentialsDialogOpen] = useState(false);
  const [lastUpdateCheck, setLastUpdateCheck] = useState(Date.now());
  
  // Manual refresh function for debugging
  const forceRefresh = () => {
    console.log('Manual refresh requested');
    window.location.reload();
  };
  
  useEffect(() => {
    console.log('Index page rendered with categories:', categories.length);
    console.log('Resources:', resources.length);
    console.log('Admin status:', isAdmin);
    console.log('Developer mode:', settings.developerMode);
    console.log('Timestamp:', _timestamp);
    console.log('Last update timestamp:', _lastUpdateTimestamp);
    console.log('Update acknowledged:', _updateAcknowledged);
    console.log('Is production environment:', isProduction);
    
    if (isProduction && settings.developerMode) {
      console.log('Forcing developer mode OFF in production');
      toggleDeveloperMode();
    }
  }, [categories, resources, isAdmin, settings, _timestamp, _lastUpdateTimestamp, _updateAcknowledged, toggleDeveloperMode]);
  
  const handleLogout = () => {
    logout();
    toast.info("Logged out successfully");
  };

  const isDeveloperMode = settings?.developerMode === true;
  
  return (
    <Layout>
      {/* Update acknowledgment handler */}
      <UpdateAcknowledgment 
        onAcknowledge={() => _updateAcknowledged}
        lastUpdateCheck={lastUpdateCheck}
        setLastUpdateCheck={setLastUpdateCheck}
        _lastUpdateTimestamp={_lastUpdateTimestamp}
      />
      
      {/* Welcome header with admin controls */}
      <WelcomeHeader 
        isAdmin={isAdmin}
        isProduction={isProduction}
        isDeveloperMode={isDeveloperMode}
        _lastUpdateTimestamp={_lastUpdateTimestamp}
        _updateAcknowledged={_updateAcknowledged}
        onLoginClick={() => setIsLoginDialogOpen(true)}
        onLogoutClick={handleLogout}
        onChangeCredentialsClick={() => setIsCredentialsDialogOpen(true)}
        onToggleDeveloperMode={toggleDeveloperMode}
        onForceRefresh={forceRefresh}
      />
      
      {/* Display all categories */}
      {categories.map(category => (
        <CategoryBlock 
          key={`${category.id}-${_timestamp}`} 
          category={category} 
          resources={resources.filter(resource => resource.categoryId === category.id)} 
        />
      ))}

      {/* Admin login dialog */}
      <AdminLoginDialog 
        isOpen={isLoginDialogOpen}
        onOpenChange={setIsLoginDialogOpen}
        onLogin={login}
      />

      {/* Change credentials dialog */}
      <ChangeCredentialsDialog 
        isOpen={isCredentialsDialogOpen}
        onOpenChange={setIsCredentialsDialogOpen}
        onChangeCredentials={changeCredentials}
      />
    </Layout>
  );
};

export default Index;
